// Regex for password complexity. This should mirror the regex seen in the response
// from zone5 cloud's GET {{base_url}}/rest/auth/password-complexity
export const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

export function validatePassword(password) {
    return passwordPattern.test(password);
}



// WEBPACK FOOTER //
// ./src/client/utils/password.js